import { Card, CardContent, CardHeader, Header, Icon, Image } from "semantic-ui-react";
import React, { useEffect, useMemo, useState } from "react";
import { b64toBlob } from "utils/file";
import { isMobile } from "utils/isMobile";

export const DocumentCard = ({ document }) => {
	const doc = useMemo(() => document, []);
	const [type, setType] = useState(null);

	useEffect(() => {
		if (document.type.includes("image")) {
			setType("image");
		}

		if (document.type.includes("pdf")) {
			setType("pdf");
		}
	}, [setType, document]);
	return (
		<div
			style={{
				width: "100%",
				display: "flex",
				flexDirection: "row",
				flexWrap: isMobile() ? "wrap" : "nowrap",
				justifyContent: "flex-start",
				alignContent: "flex-start",
				alignItems: "flex-start",
				gap: 12,
			}}
		>
			<Card>
				{type === "image" && (
					<CardHeader>
						<Image rounded src={URL.createObjectURL(b64toBlob(doc.base64, document.type))} size="medium" />
					</CardHeader>
				)}
				<CardContent>
					<div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
						<Header as="h5">
							{document.document_type.title} № {document.document_type.order}
						</Header>
						<div>
							<Icon name="barcode" />{" "}
							<b>
								<i>{document.barcode}</i>
							</b>
						</div>
						<div>
							{type === "image" && <Icon name="image" />} {type === "pdf" && <Icon name="file pdf" />} {document.type}
						</div>
					</div>
				</CardContent>
			</Card>
			<div style={{ alignItems: "center", width: "100%", display: "flex", justifyContent: "center" }}>
				{type === "image" && <Image rounded src={URL.createObjectURL(b64toBlob(doc.base64, document.type))} />}
				{type === "pdf" && (
					<iframe
						id="fraDisabled"
						//Prevent download
						src={URL.createObjectURL(b64toBlob(doc.base64, "application/pdf")) + "#toolbar=1"}
						title="Ordonnance renouvelable"
						name="Ordonnance renouvelable"
						style={{
							height: "600px",
							width: "100%",
						}}
					></iframe>
				)}
			</div>
		</div>
	);
};
